import { requestJson, requestMultipart } from "@/lib/api";

const BASE = "api/v1/admin/certificates";
const ESTAB = "api/v1/admin/establishments";

export interface Establishment {
  id: string;
  cnpj: string;
  name: string;
}

/** Estabelecimentos para o seletor. 403 (sem permissão) tratado inline na tela, sem toast global. */
export async function listEstablishments(): Promise<Establishment[]> {
  return requestJson<Establishment[]>(ESTAB, { silentForbidden: true });
}

/** Metadados do certificado A1 (B). O material privado NUNCA é retornado nem baixável. */
export interface Certificate {
  id: string;
  establishmentId: string;
  holderName: string;
  holderDocument: string;
  issuerName: string;
  serialNumber: string;
  validFrom: string;
  validTo: string;
  daysRemaining: number;
  situation: "VALIDO" | "A_VENCER" | "VENCIDO" | "NAO_VIGENTE";
  inUse: boolean;
  status: "ATIVO" | "SUBSTITUIDO";
  keyVersion: number;
  fingerprintSha256: string;
  uploadedAt: string;
  supersededAt: string | null;
  deactivatedAt: string | null;
}

/** Lista (metadados) os certificados de um estabelecimento — ativo + histórico. */
export async function listCertificates(establishmentId: string): Promise<Certificate[]> {
  return requestJson<Certificate[]>(`${BASE}?establishmentId=${encodeURIComponent(establishmentId)}`);
}

/**
 * Upload do A1 (PKCS12) + senha pela interface segura (multipart HTTPS). A senha só abre o material; não é
 * persistida. Substitui atomicamente o certificado em uso do estabelecimento.
 */
export async function uploadCertificate(establishmentId: string, file: File, password: string): Promise<Certificate> {
  const form = new FormData();
  form.append("establishmentId", establishmentId);
  form.append("file", file);
  form.append("password", password);
  return requestMultipart<Certificate>(`${BASE}`, form);
}

/** Desativa o certificado em uso (sem sucessor): o estabelecimento fica sem certificado (fail-closed). */
export async function deactivateCertificate(certificateId: string): Promise<void> {
  await requestJson<void>(`${BASE}/${encodeURIComponent(certificateId)}/deactivate`, { method: "POST" });
}
